export const IGNORE_ROUTES = ['/', '/login'];
